<template>
  <div class="nomenclature">
    <Header />
    <div>
      <div class="uk-flex" v-if="!isLoadingNomenclature" uk-height-viewport>
        <div class="uk-width-1-5 uk-background-secondary uk-padding-small uk-animation-fade">
          <ul class="uk-nav-default uk-nav-parent-icon" uk-nav>
            <li class="uk-parent uk-text-left" v-for="(service, index) in services" :key="index">
              <a
                class="uk-padding-remove uk-text-truncate"
                v-on:click="didPressNomenclature(service)"
              >{{service.title}}</a>
              <ul uk-nav>
                <li
                  :class="isCSSClassParent(elem)"
                  v-for="(elem, index) in service.elements"
                  :key="index"
                  class="uk-margin-left"
                >
                  <a
                    class="uk-padding-remove uk-text-truncate"
                    v-on:click="didPressNomenclature(elem)"
                  >{{elem.title}}</a>
                  <ul>
                    <li>
                      <Arborescence
                        :id="elem.uid"
                        @didPressNomenclature="didPressNomenclature"
                        :element="elem"
                        v-if="elem.elements.length > 0"
                      ></Arborescence>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li class="uk-nav-divider"></li>
            <li class="uk-nav-header">v1.1</li>
          </ul>
        </div>
        <div
          class="uk-width-4-5 uk-margin-left uk-margin-small-top uk-margin-remove-right"
          v-if="selectedElement !== undefined"
        >
          <!-- Breadcrumbs -->
          <div>
            <ul class="uk-breadcrumb">
              <li v-for="(crumb, index) in breadcrumbs" :key="index">
                <a
                  v-if="index !== (breadcrumbs.length - 1)"
                  v-on:click="updateBreadcrumbsWith(crumb)"
                >{{crumb.title}}</a>
                <span v-else>{{crumb.title}}</span>
              </li>
            </ul>
          </div>

          <div class="uk-margin-bottom">
            <h3 class="uk-title uk-text-bold">
              {{selectedElement.title}}
              <span
                style="cursor:pointer;"
                class="uk-form-success"
                uk-icon="icon: move"
                v-show="selectedElement.type !== 'service'"
                v-on:click="setCopyElement()"
              ></span>
              <div
                class="uk-margin-left uk-animation-slide-left-small uk-animation-reverse"
                v-show="isSaving"
                uk-spinner
              ></div>
            </h3>
          </div>

          <div class="uk-grid uk-flex uk-margin-medium-bottom" uk-grid>
            <div class="uk-margin-left uk-text-left uk-text-bold uk-width-expand">Intitulé</div>
            <div class="uk-text-middle uk-text-bold uk-width-medium">Type</div>
            <div class="uk-text-middle uk-text-bold uk-width-small">Valeurs</div>
            <div class="uk-text-middle uk-text-bold uk-width-small">Obligatoire</div>
            <div class="uk-text-middle uk-text-bold uk-width-small">Activé</div>
            <div class="uk-text-middle uk-text-bold uk-width-small">Actions</div>
          </div>
          <div
            id="sortable"
            uk-sortable
            data-uk-sortable
            v-show="selectedElement.elements.length > 0 && !isSortableSaving"
          >
            <div
              v-for="(element, index) in selectedElement.elements"
              :key="element.uid"
              class="uk-grid-auto uk-flex table-row uk-margin-small-bottom"
              :id="element.uid"
              uk-grid
            >
              <div class="uk-text-left uk-text-bold uk-text-middle uk-width-expand">
                <input
                  class="uk-input uk-form-blank uk-form-width-expand uk-text-small"
                  type="text"
                  placeholder="Intitulé"
                  v-model="element.title"
                  v-on:blur="save(index)"
                />
              </div>
              <div class="uk-text-middle uk-width-medium">
                <div uk-form-custom="target: > * > span:first-child">
                  <select v-model="selectedElement.elements[index].type" @change="save(index)">
                    <option
                      v-for="(type, typeIndex) in data.elementTypes"
                      :key="typeIndex"
                      v-bind:value="type.type"
                    >{{type.title}}</option>
                  </select>
                  <button class="uk-button uk-button-default" type="button" tabindex="-1">
                    <span></span>
                    <span uk-icon="icon: chevron-down"></span>
                  </button>
                </div>
              </div>

              <div
                class="uk-text-middle uk-width-small"
                style="cursor:pointer;"
                v-on:click="element.type === 'attribute' ? editElementValuesFor(element) : ''"
                :href="element.type === 'attribute' ? '#modal-sections' : ''"
                uk-toggle
              >
                <p
                  v-show="element.type === 'attribute'"
                  class="uk-text-truncate uk-text-small uk-width-medium uk-margin-small-top"
                >{{element.values.join(', ')}}</p>
              </div>

              <div
                class="uk-text-middle uk-text-bold uk-vertical-align uk-width-small"
                :class="CSSClassFor(element)"
              >
                <span
                  v-on:click="didPressMandatoryButtonFor(index)"
                  v-if="element.isMandatory"
                  class="uk-label uk-label-success uk-margin-small-top"
                >Oui</span>
                <span
                  v-on:click="didPressMandatoryButtonFor(index)"
                  v-else
                  class="uk-label uk-label-danger uk-margin-small-top"
                >Non</span>
              </div>

              <div class="uk-text-middle uk-text-bold uk-width-small">
                <span
                  v-on:click="didPressActivateButtonFor(index)"
                  v-if="element.isActive"
                  class="uk-label uk-label-success uk-margin-small-top"
                >Activé</span>
                <span
                  v-on:click="didPressActivateButtonFor(index)"
                  v-else
                  class="uk-label uk-label-danger uk-margin-small-top"
                >Désactivé</span>
              </div>

              <div class="uk-text-middle uk-width-small">
                <span
                  class="uk-form-success uk-margin-right uk-margin-small-top"
                  style="cursor:pointer;"
                  uk-icon="move"
                  uk-tooltip="title: Copier; delay: 500"
                  v-on:click="setCopyElement(index)"
                ></span>
                <span
                  class="uk-form-success uk-margin-right uk-margin-small-top"
                  style="cursor:pointer;"
                  uk-icon="copy"
                  uk-tooltip="title: Dupliquer; delay: 500"
                  v-on:click="duplicateElementAt(index)"
                ></span>
                <span
                  class="uk-form-danger uk-margin-small-top"
                  style="cursor:pointer;"
                  uk-icon="trash"
                  v-on:click="deleteRowAt(index)"
                ></span>
              </div>
            </div>
          </div>

          <!-- MODAL NEW VALUE -->
          <div id="modal-sections" uk-modal>
            <div class="uk-modal-dialog">
              <button class="uk-modal-close-default" type="button" uk-close></button>
              <div class="uk-modal-header">
                <h2 class="uk-modal-title">{{selectedRow.title}}</h2>
              </div>

              <div class="uk-modal-body">
                <div class="uk-grid-small uk-flex" uk-grid>
                  <p class="uk-text-middle">Type de valeur</p>
                  <div class="uk-text-middle uk-width-expand uk-align-right">
                    <div uk-form-custom="target: > * > span:first-child">
                      <select v-model="selectedRow.valueType">
                        <option
                          v-for="(valueType, index) in data.valueTypes"
                          :key="index"
                          v-bind:value="valueType.type"
                        >{{valueType.title}}</option>
                      </select>
                      <button
                        class="uk-button uk-button-default uk-border-rounded"
                        type="button"
                        tabindex="-1"
                      >
                        <span></span>
                        <span uk-icon="icon: chevron-down"></span>
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  class="uk-grid-small uk-flex"
                  v-show="selectedRow.valueType !== 'written'"
                  uk-grid
                >
                  <div
                    class="uk-margin-small-bottom"
                    v-for="(value, index) in selectedRow.values"
                    :key="index"
                  >
                    <input
                      class="uk-input uk-form-width-large uk-border-rounded"
                      type="text"
                      placeholder="Intitulé"
                      v-model="selectedRow.values[index]"
                    />
                    <span
                      class="uk-form-danger uk-margin-left"
                      style="cursor:pointer;"
                      uk-icon="trash"
                      v-on:click="deleteValueAt(index)"
                    ></span>
                  </div>
                  <div>
                    <input
                      class="uk-input uk-form-width-large uk-border-rounded uk-background-secondary"
                      type="text"
                      placeholder="Intitulé"
                      v-model="newValue"
                    />
                    <span
                      class="uk-form-success uk-margin-left"
                      style="cursor:pointer;"
                      uk-icon="plus"
                      v-on:click="addNewValue()"
                    ></span>
                  </div>
                  <p class="uk-margin-top">{{selectedRow.values.length}} valeurs renseignées.</p>
                </div>
              </div>
              <div class="uk-modal-footer uk-text-right">
                <button
                  class="uk-button uk-button-default uk-modal-close uk-border-rounded uk-margin-right"
                  type="button"
                >Annuler</button>
                <button
                  class="uk-button uk-button-primary uk-modal-close uk-border-rounded"
                  type="button"
                  v-on:click="save()"
                >Sauvegarder</button>
              </div>
            </div>
          </div>

          <!-- New Element -->

          <div v-if="copyElement !== undefined" class="uk-margin-right">
            <button
              class="uk-button uk-button-primary uk-border-rounded"
              type="button"
              v-on:click="pasteElement()"
            >Coller l'élément</button>
            <h6 class="uk-text-muted uk-text-center uk-margin-remove-top">{{copyElement.title}}</h6>
          </div>
          <div
            class="uk-grid-small uk-margin-medium-top uk-flex uk-background-secondary"
            v-show="selectedElement.type === 'element' || selectedElement.type === 'service'"
            uk-grid
          >
            <div class="uk-text-left uk-margin-left uk-text-bold uk-text-middle uk-width-expand">
              <input
                class="uk-input uk-form-blank uk-form-width-expand"
                type="text"
                placeholder="Intitulé"
                v-model="newElement.title"
              />
            </div>
            <div class="uk-text-middle uk-width-medium">
              <div uk-form-custom="target: > * > span:first-child">
                <select v-model="newElement.type">
                  <option
                    v-for="(type, index) in data.elementTypes"
                    :key="index"
                    v-bind:value="type.type"
                  >{{type.title}}</option>
                </select>
                <button class="uk-button uk-button-default" type="button" tabindex="-1">
                  <span></span>
                  <span uk-icon="icon: chevron-down"></span>
                </button>
              </div>
            </div>

            <div
              class="uk-text-middle uk-width-medium"
              style="cursor:pointer;"
              v-on:click="newElement.type === 'attribute' ? editElementValuesFor(newElement) : ''"
              href="#modal-sections"
              uk-toggle
            >
              <p
                class="uk-text-truncate uk-width-medium uk-margin-small-top"
              >{{newElement.values.join(', ')}}</p>
            </div>

            <div
              class="uk-text-middle uk-text-bold uk-width-small"
              :class="CSSClassFor(newElement)"
            >
              <span
                v-on:click="newElement.isMandatory = !newElement.isMandatory"
                v-if="newElement.isMandatory"
                class="uk-label uk-label-success uk-margin-small-top"
              >Oui</span>
              <span
                v-on:click="newElement.isMandatory = !newElement.isMandatory"
                v-else
                class="uk-label uk-label-danger uk-margin-small-top"
              >Non</span>
            </div>

            <div class="uk-text-middle uk-text-bold uk-width-small">
              <span
                v-on:click="newElement.isActive = !newElement.isActive"
                v-if="newElement.isActive"
                class="uk-label uk-label-success uk-margin-small-top"
              >Activé</span>
              <span
                v-on:click="newElement.isActive = !newElement.isActive"
                v-else
                class="uk-label uk-label-danger uk-margin-small-top"
              >Désactivé</span>
            </div>

            <div class="uk-text-middle uk-width-small">
              <span
                class="uk-form-success uk-margin-small-top"
                style="cursor:pointer;"
                uk-icon="plus"
                v-on:click="addNewElement()"
              ></span>
            </div>
          </div>
        </div>
      </div>
      <div v-else uk-height-viewport>
        <div class="uk-flex-middle uk-margin-large-top uk-align-center" uk-spinner></div>
        <p>Récupération de la nomenclature...</p>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from "uikit";
import FirestoreCollection from "../enums/firestore-collection";
import ElementType from "../enums/element-type";
import ValueType from "../enums/value-type";
import NotificationType from "../enums/notification-type";
import Header from "../components/Header";
import Arborescence from "../components/Arborescence";
import Element from "../models/element";
import firebase from "firebase";
import $ from "jquery";

export default {
  name: "nomenclature",
  components: {
    Header,
    Arborescence
  },
  mounted() {
    const self = this;
    firebase
      .firestore()
      .collection(FirestoreCollection.SERVICES)
      .doc(process.env.VUE_APP_DEFAULT_CHECK_COLLECTION_ID)
      .get()
      .then(doc => {
        if (doc.exists) {
          self.services.push(new Element(doc));
        }
        firebase
          .firestore()
          .collection(
            FirestoreCollection.SERVICES +
              "/" +
              process.env.VUE_APP_DEFAULT_CHECK_COLLECTION_ID +
              "/Elements"
          )
          .orderBy("title")
          .limit(200)
          .get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              var element = new Element(doc);
              element.parentObject = self.services[0];
              self.services[0].elements.push(element);
            });
            self.isLoadingNomenclature = false;
          })
          .catch(function(error) {
            console.log("Error getting documents: ", error);
          });
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });

    UIkit.util.on(document, "moved", "#sortable", function() {
      var ids = [];
      $("#sortable")
        .find("div")
        .each(function() {
          var id = $(this).attr("id");
          if (id !== undefined) ids.push(id);
        });
      self.sortElement(ids);
    });
  },

  data() {
    return {
      isLoadingNomenclature: true,
      isSortableSaving: false,
      isSaving: false,
      services: [],
      breadcrumbs: [],
      newElement: new Element(),
      selectedElement: undefined,
      copyElement: undefined,
      selectedRow: { values: [] },
      newValue: "",
      data: {
        elementTypes: [
          {
            type: ElementType.ELEMENT,
            title: "Élément"
          },
          {
            type: ElementType.ATTRIBUTE,
            title: "Attribut"
          }
        ],
        valueTypes: [
          {
            type: ValueType.WRITTEN,
            title: "Écrite"
          },
          {
            type: ValueType.SINGLE,
            title: "Choix unique"
          },
          {
            type: ValueType.MULTI,
            title: "Choix multiple"
          }
        ]
      }
    };
  },
  methods: {
    sortElement: function(ids) {
      if (this.selectedElement == undefined) return;
      for (let index = 0; index < ids.length; index++) {
        const id = ids[index];
        const foundIndex = this.selectedElement.elements.findIndex(
          e => e.uid === id
        );
        if (index != foundIndex) {
          this.selectedElement.elements = this.moveArrayItemToNewIndex(
            foundIndex,
            index
          );
        }
      }
      for (
        let index = 0;
        index < this.selectedElement.elements.length;
        index++
      ) {
        this.selectedElement.elements[index].order = index;
      }

      this.$forceUpdate();
      this.save();
    },

    moveArrayItemToNewIndex: function(old_index, new_index) {
      var array = this.selectedElement.elements;
      if (new_index >= array.length) {
        var k = new_index - array.length + 1;
        while (k--) {
          array.push(undefined);
        }
      }
      array.splice(new_index, 0, array.splice(old_index, 1)[0]);
      return array;
    },

    setCopyElement: function(index) {
      if (index == undefined) {
        this.copyElement = new Element(this.selectedElement, true);
      } else {
        this.copyElement = new Element(
          this.selectedElement.elements[index],
          true
        );
      }
    },

    pasteElement: function() {
      this.copyElement.parentUID = this.selectedElement.uid;
      this.copyElement.parentObject = this.selectedElement;
      this.selectedElement.elements.push(this.copyElement);
      if (
        this.breadcrumbs.length == 1 &&
        this.breadcrumbs[0].uid ===
          process.env.VUE_APP_DEFAULT_CHECK_COLLECTION_ID
      ) {
        this.saveRootDuplicatedElement(this.copyElement);
      } else {
        this.save();
      }
      this.copyElement = undefined;
    },

    didPressNomenclature: function(element) {
      this.updateBreadcrumbsWith(element);
    },

    addNewElement: function() {
      const self = this;
      this.newElement.parentUID = this.selectedElement.uid;
      this.newElement.parentObject = this.selectedElement;

      if (this.newElement.type == ElementType.ELEMENT) {
        const etatGeneral = new Element();
        etatGeneral.parentUID = this.newElement.uid;
        etatGeneral.isActive = true;
        etatGeneral.isMandatory = false;
        etatGeneral.order = "0";
        etatGeneral.title = "ÉTAT GÉNÉRAL";
        etatGeneral.valueType = ValueType.MULTI;
        etatGeneral.values = [
          "NEUF",
          "BON ÉTAT",
          "FONCTIONNE",
          "ÉTAT D'USAGE",
          "DÉGRADÉ",
          "VÉTUSTE",
          "NE FONCTIONNE PAS"
        ];
        this.newElement.elements.unshift(etatGeneral);
      }
      console.log(this.newElement);

      if (
        this.breadcrumbs.length == 1 &&
        this.breadcrumbs[0].uid ===
          process.env.VUE_APP_DEFAULT_CHECK_COLLECTION_ID
      ) {
        self.isSaving = true;
        firebase
          .firestore()
          .collection(FirestoreCollection.SERVICES)
          .doc(process.env.VUE_APP_DEFAULT_CHECK_COLLECTION_ID)
          .collection(FirestoreCollection.ELEMENTS)
          .doc(this.newElement.uid)
          .set(this.newElement.data, { merge: false })
          .then(() => {
            self.isSaving = false;
            self.selectedElement.elements.push(self.newElement);
            self.newElement = new Element();
            self.displayMessage(
              "Nouvel élément ajouté avec succès.",
              NotificationType.SUCCESS
            );
          })
          .catch(function(error) {
            self.displayMessage(
              "Nouvel élément non sauvegardé.",
              NotificationType.ERROR
            );
            console.log("Error saving documents: ", error);
          });
      } else {
        this.selectedElement.elements.push(this.newElement);
        this.newElement = new Element();
        this.save();
      }
    },

    addNewValue: function() {
      this.selectedRow.values.push(this.newValue);
      this.newValue = "";
    },

    deleteValueAt: function(index) {
      this.selectedRow.values.splice(index, 1);
      const elementIndex = this.services[0].elements.findIndex(
        e => e.uid === this.selectedRow.uid
      );
      this.save(elementIndex);
    },

    save: function(index) {
      const self = this;
      this.isSaving = true;
      if (
        this.breadcrumbs.length == 1 &&
        this.breadcrumbs[0].uid ===
          process.env.VUE_APP_DEFAULT_CHECK_COLLECTION_ID
      ) {
        let element = this.services[0].elements[index];
        firebase
          .firestore()
          .collection(FirestoreCollection.SERVICES)
          .doc(process.env.VUE_APP_DEFAULT_CHECK_COLLECTION_ID)
          .collection(FirestoreCollection.ELEMENTS)
          .doc(element.uid)
          .set(element.data, { merge: true })
          .then(() => {
            self.isSaving = false;
            self.isSortableSaving = false;
            self.displayMessage(
              "Synchronisation réussie.",
              NotificationType.SUCCESS
            );
          })
          .catch(function(error) {
            self.displayMessage(
              "Dernière modification non sauvegardée.",
              NotificationType.ERROR
            );
            console.log("Error saving documents: ", error);
          });
      } else {
        firebase
          .firestore()
          .collection(FirestoreCollection.SERVICES)
          .doc(process.env.VUE_APP_DEFAULT_CHECK_COLLECTION_ID)
          .collection(FirestoreCollection.ELEMENTS)
          .doc(this.breadcrumbs[1].uid)
          .set(this.breadcrumbs[1].data, { merge: true })
          .then(() => {
            self.isSaving = false;
            self.isSortableSaving = false;
            self.displayMessage(
              "Element sauvegardé.",
              NotificationType.SUCCESS
            );
          })
          .catch(function(error) {
            self.displayMessage(
              "Dernière modification non sauvegardée.",
              NotificationType.ERROR
            );
            console.log("Error saving documents: ", error);
          });
      }
    },

    updateBreadcrumbsWith: function(element) {
      this.newElement = new Element();
      this.breadcrumbs = [];
      var check = element;
      while (check !== undefined) {
        this.breadcrumbs.unshift(check);
        check = check.parentObject;
      }
      this.selectedElement = this.breadcrumbs[this.breadcrumbs.length - 1];
    },

    duplicateElementAt: function(index) {
      const duplicated = this.selectedElement.elements[index];
      var duplicate = new Element(duplicated, true);
      duplicate.title = duplicate.title + " - Copie";
      duplicate.parentObject = this.selectedElement;
      this.selectedElement.elements.push(duplicate);
      if (
        this.breadcrumbs.length == 1 &&
        this.breadcrumbs[0].uid ===
          process.env.VUE_APP_DEFAULT_CHECK_COLLECTION_ID
      ) {
        this.saveRootDuplicatedElement(duplicate);
      } else {
        this.save();
      }
    },

    saveRootDuplicatedElement: function(element) {
      const self = this;
      firebase
        .firestore()
        .collection(FirestoreCollection.SERVICES)
        .doc(process.env.VUE_APP_DEFAULT_CHECK_COLLECTION_ID)
        .collection(FirestoreCollection.ELEMENTS)
        .doc(element.uid)
        .set(element.data, { merge: true })
        .then(() => {
          self.isSaving = false;
          self.isSortableSaving = false;
          self.displayMessage(
            "Synchronisation réussie.",
            NotificationType.SUCCESS
          );
        })
        .catch(function(error) {
          self.displayMessage(
            "Dernière modification non sauvegardée.",
            NotificationType.ERROR
          );
          console.log("Error saving documents: ", error);
        });
    },

    editElementValuesFor: function(element) {
      this.selectedRow = element;
    },

    deleteRowAt: function(index) {
      if (
        confirm(
          "Êtes vous sûr(e) de vouloir supprimer cette ligne ? Cela supprimera tout ce qu'elle contient."
        )
      ) {
        const self = this;
        self.isSaving = true;
        if (
          this.breadcrumbs.length == 1 &&
          this.breadcrumbs[0].uid ===
            process.env.VUE_APP_DEFAULT_CHECK_COLLECTION_ID
        ) {
          let uid = this.services[0].elements[index].uid;
          firebase
            .firestore()
            .collection(FirestoreCollection.SERVICES)
            .doc(process.env.VUE_APP_DEFAULT_CHECK_COLLECTION_ID)
            .collection(FirestoreCollection.ELEMENTS)
            .doc(uid)
            .delete()
            .then(() => {
              self.isSaving = false;
              this.services[0].elements.splice(index, 1);
              self.displayMessage(
                "Element supprimé avec succès.",
                NotificationType.SUCCESS
              );
            })
            .catch(function(error) {
              self.displayMessage(
                "Erreur lors de la suppression..",
                NotificationType.ERROR
              );
              console.log("Error saving documents: ", error);
            });
        } else {
          this.selectedElement.elements.splice(index, 1);
          this.save();
        }
      }
    },

    shouldDisplayValueFor: function(index) {
      return this.selectedElement.elements[index].type != ElementType.ELEMENT;
    },

    shouldDisplayInputValue: function(index) {
      return (
        this.selectedElement.elements[index].valueType == ValueType.WRITTEN
      );
    },

    didPressMandatoryButtonFor: function(index) {
      this.selectedElement.elements[index].isMandatory = !this.selectedElement
        .elements[index].isMandatory;
      if (
        this.breadcrumbs.length == 1 &&
        this.breadcrumbs[0].uid ===
          process.env.VUE_APP_DEFAULT_CHECK_COLLECTION_ID
      ) {
        this.save(index);
      } else {
        this.save();
      }
    },

    didPressActivateButtonFor: function(index) {
      this.selectedElement.elements[index].isActive = !this.selectedElement
        .elements[index].isActive;
      if (
        this.breadcrumbs.length == 1 &&
        this.breadcrumbs[0].uid ===
          process.env.VUE_APP_DEFAULT_CHECK_COLLECTION_ID
      ) {
        this.save(index);
      } else {
        this.save();
      }
    },

    CSSClassFor: function(element) {
      return element.isActive ? "" : "transparent";
    },

    displayMessage: function(message, status) {
      UIkit.notification("<span uk-icon='check: warning'></span> " + message, {
        pos: "top-right",
        status: status
      });
    },

    getCSSClass: function(element) {
      return element.type == ElementType.ATTRIBUTE
        ? "uk-nav-sub"
        : "uk-nav-default uk-nav-parent-icon";
    },

    isCSSClassParent: function(element) {
      return element.type == ElementType.ATTRIBUTE ? "" : "uk-parent";
    }
  }
};

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
};
</script>

<style scoped>
.uk-background-secondary {
  background-color: #309fb520;
}

.table-row:hover {
  background-color: rgba(48, 158, 181, 0.05);
}

.transparent {
  opacity: 0.33;
}
</style>